import modelTree from './views/model-tree.vue'


export default {
    modelTree,
};
